export function formatAccountingReferenceLabel(
  title: string,
  referenceNumber?: string | null,
): string {
  const trimmedTitle = (title ?? "").trim();
  const num = referenceNumber?.trim();
  if (num) {
    return `${trimmedTitle} · ${num}`;
  }
  return trimmedTitle;
}

export function accountingReferenceMatchesQuery(
  title: string,
  referenceNumber: string | null | undefined,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) {
    return true;
  }
  const t = (title ?? "").toLowerCase();
  const n = (referenceNumber ?? "").toLowerCase();
  return t.includes(q) || n.includes(q);
}
